import { useCallback } from "react";
import { useAnalytics } from "@hooks/useAnalytics";
import { mixpanelAccessProps } from "@src/utils/mixpanelAccess";

/**
 * OP-3133: `trackEvent` that stamps `access_method` on every event, so a caller
 * cannot forget it. The event's own properties win on a name clash.
 */
export const useAccessMethodTrackEvent = (accessMethod?: string | null) => {
  const { trackEvent } = useAnalytics();

  return useCallback(
    (event: string, params?: Record<string, unknown>, mixpanelOnly?: boolean) =>
      trackEvent(
        event,
        {
          ...mixpanelAccessProps(accessMethod),
          ...params,
        },
        mixpanelOnly,
      ),
    [trackEvent, accessMethod],
  );
};
